module.exports = __webpack_public_path__ + "static/media/caixa.fb11c14e.webp";